<template>
  <li v-bind:class="{ 'selected': selected }">
    <a :href="path" class="mb-2 px-2 feature-item" @click.prevent="$emit('select-feature')">
      <div class="feature-item__layer-name">{{ feature.layer.name }}</div>
      <div class="feature-item__feature-name">{{ feature.name }}</div>
    </a>
  </li>
</template>

<script>
export default {
  props: ["feature", "selected"],
  computed: {
    path() {
      return `/features/${this.feature.id}`
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/mixins";

li {
  @include media-breakpoint-down(lg) {
    display: inline-block;
  }
}

a.feature-item {
  border: solid rgba(60, 90, 127, 0.5);
  border-width: 0 0 0 5px;
  color: #333;
  display: block;

  .selected & {
    border-color: #3c5a7f;
  }

  @include media-breakpoint-down(lg) {
    border-width: 2px 0 0 0;
    margin-right: 2px;
  }
}

.feature-item__layer-name {
  font-size: 10px;
}

.feature-item__feature-name {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Address/FeatureItem.vue